<div *ngIf="this.tiers" id="tier-nav-btns">
  <div *ngIf="(canEdit && canMoveTiers)" cdkDropList (cdkDropListDropped)="dropped($event)">
    <div
      *ngFor="let tier of tiers; let i = index"
      (click)="selectTier(tier)"
      cdkDrag
      class="tier-step"
      fxLayout="row"
      [ngClass]="{ 'active-tier': isSelected(tier.id) }"
    >
      <div *ngIf="!workoutType && canEdit && canMoveTiers">
        <mat-icon class="drag-handle" cdkDragHandle>drag_handle</mat-icon>
      </div>
      <div fxLayout="column" fxLayoutAlign="center center" style="margin-right: 15px; min-height: 80px;">
        <div fxLayout="row">
          <div class="tier-num">
            {{ i + 1 }}
          </div>
        </div>
        <div class="line" fxFlex>&nbsp;</div>
      </div>
      <div fxFlex class="tier-metadata" fxLayout="column">
        <strong>{{ tier.name }}</strong>
        <span *ngIf="tier.rows.length >= 1 && tier.rows[0] && tier.rows[0].exercise_name">{{ tier.rows[0].exercise_name }}</span>
        <span *ngIf="tier.rows.length >= 2 && tier.rows[1] && tier.rows[1].exercise_name">{{ tier.rows[1].exercise_name }}</span>
        <span *ngIf="tier.rows.length >= 3 && tier.rows[2] && tier.rows[2].exercise_name">…</span>
      </div>
    </div>
  </div>
  <div *ngIf="!canMoveTiers">
    <div
      *ngFor="let tier of tiers; let i = index"
      (click)="selectTier(tier)"
      class="tier-step"
      fxLayout="row"
      [ngClass]="{ 'active-tier': isSelected(tier.id) }"
    >
      <div fxLayout="column" fxLayoutAlign="center center" style="margin-right: 15px; min-height: 80px;">
        <div fxLayout="row">
          <div class="tier-num">
            {{ i + 1 }}
          </div>
        </div>
        <div class="line" fxFlex>&nbsp;</div>
      </div>
      <div fxFlex class="tier-metadata" fxLayout="column">
        <strong>{{ tier.name }}</strong>
        <span *ngIf="tier.rows.length >= 1 && tier.rows[0] && tier.rows[0].exercise_name">{{ tier.rows[0].exercise_name }}</span>
        <span *ngIf="tier.rows.length >= 2 && tier.rows[1] && tier.rows[1].exercise_name">{{ tier.rows[1].exercise_name }}</span>
        <span *ngIf="tier.rows.length >= 3 && tier.rows[2] && tier.rows[2].exercise_name">…</span>
      </div>
    </div>
  </div>

  <div>
    <button mat-raised-button color="primary" [disabled]="(!canEdit || !canMoveTiers || tierTemplate)" (click)="addEmptyTier()">
      Add tier
    </button>
  </div>
</div>
